import React from "react";
import { ArrowRight } from "lucide-react";
import { hoodies } from "../mock";
import ProductCard from "./ProductCard";

export default function HoodiesSection() {
  return (
    <section id="hoodies" className="bg-[color:var(--dms-cream-2)] py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
        <p className="kicker">Hoodies &amp; Sweatshirts</p>
        <h2 className="font-serif text-4xl md:text-5xl text-[color:var(--dms-navy)] mt-4">For the colder half of the year</h2>
        <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mx-auto mt-5" />
        <p className="mt-6 text-[color:var(--dms-navy)]/70 max-w-2xl mx-auto leading-relaxed">
          Heavier fleece, bigger print area, and the piece people actually keep. Choose your weight, then print your design or ours.
        </p>
      </div>
      <div className="max-w-4xl mx-auto px-5 lg:px-8 mt-14 grid grid-cols-1 sm:grid-cols-2 gap-8">
        {hoodies.map((h) => <ProductCard key={h.id} product={h} />)}
      </div>
      <div className="text-center mt-12">
        <a href="#hoodies" className="btn-navy">Shop hoodies &amp; sweatshirts <ArrowRight className="w-4 h-4" /></a>
      </div>
    </section>
  );
}
